import { Body, Container, Heading, ContainerProps } from '@hover/blueprint';
import React from 'react';

interface Props extends ContainerProps {
  title?: string;
  header: string | JSX.Element;
  topBody: string | JSX.Element;
  bottomBody?: string | JSX.Element;
  titleColor?: string;
}

const ContentCard: React.FC<Props> = ({
  title,
  header,
  topBody,
  bottomBody,
  titleColor,
  ...restProps
}) => (
  <Container flexDir="column" maxW="lg" px={0} {...restProps}>
    {title && (
      <Body letterSpacing="1px" color={titleColor} size={200} isBold mb={200}>
        {title}
      </Body>
    )}
    <Heading
      size={{ base: 500, tablet: 600 }}
      fontWeight={{ base: 600, tablet: 600 }}
      marginBottom={{ base: 500, tablet: 200 }}
      as="h2"
    >
      {header}
    </Heading>
    <Body size={500} mb={500}>
      {topBody}
    </Body>
    <Body size={500}>{bottomBody}</Body>
  </Container>
);

ContentCard.defaultProps = {
  titleColor: 'neutral.600',
  bottomBody: '',
};

export default ContentCard;
